export default {
    unittype_event_create_success_message: "Se ha creado el evento",
    unittype_event_create_title: "Crear tipo de evento de unidad",
    unittype_event_edit_success_message: "El tipo de evento de unidad ha sido editado",
    unittype_event_edit_title: "Editar tipo de evento de unidad",
    unittype_event_name: "Nombre",
    unittype_event_status: "Estado",
    unittype_event_active: "Activo",
    unittype_event_inactive: "Inactivo",
    unittype_event_diagnostic: "Diagnóstico",
    unittype_event_tab_general: "General",
    unittype_event_tab_unit_type_event: "Typo de Evento de Unidad",
    unittype_event_manufacturer: "Fabricante",
    unittype_event_unit_type: "Tipo de Unidad",
    unittype_event_event: "Evento",
    unittype_event_raw_event: "Evento sin Procesar",
    unittype_event_already_exists: "El tipo de evento de unidad ya existe, para este tipo de unidad",


}